module.exports = __webpack_public_path__ + "svg/photo-likes.svg?b8da665fd3e484a1ff33a352751b3aaa";